// PaySlipTemplateReducer.js
import * as PayslipTypes from "../../types/admin/PayslipTypes";

// Get All Templates
export const getAllPayslipReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PayslipTypes.GET_ALL_PAYSLIPS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PayslipTypes.GET_ALL_PAYSLIPS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PayslipTypes.GET_ALL_PAYSLIPS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Create Template
export const createPayslipReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PayslipTypes.CREATE_PAYSLIP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PayslipTypes.CREATE_PAYSLIP_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PayslipTypes.CREATE_PAYSLIP_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Update Template
export const updatePayslipReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PayslipTypes.UPDATE_PAYSLIP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PayslipTypes.UPDATE_PAYSLIP_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PayslipTypes.UPDATE_PAYSLIP_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Delete Template
export const deletePayslipReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PayslipTypes.DELETE_PAYSLIP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PayslipTypes.DELETE_PAYSLIP_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PayslipTypes.DELETE_PAYSLIP_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Set Default Template
export const getOnePayslipReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PayslipTypes.GET_ONE_PAYSLIP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PayslipTypes.GET_ONE_PAYSLIP_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PayslipTypes.GET_ONE_PAYSLIP_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Update Template
export const updatePayslipStatusReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PayslipTypes.UPDATE_PAYSLIP_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PayslipTypes.UPDATE_PAYSLIP_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PayslipTypes.UPDATE_PAYSLIP_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};
